import styled from '@emotion/styled';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import { __ } from '../../helpers/TranslationService';
import { Modal } from '../Modal';
import ToggleSwitch from '../ToggleSwitch';
import { Link } from './../Link';
import { TrackComponent } from './../TrackComponent';
import { ActionBarStyled } from '../ActionBar/ActionBar';
import { BreakpointsEnum } from '../../helpers/breakpoints';

const StyledModal = styled(Modal)`
    .modalContent {
        display: flex;
        flex-direction: column;
        max-width: 500px;
        max-height: 80%;
        top: 50%;
        transform: translateY(-50%);
        overflow: hidden;
    }

    .allInclusiveDescription {
        margin-top: 30px;
        padding: 0 20px 20px;
        text-align: left;
        max-height: 100%;
        overflow-y: scroll;
        font-size: 14px !important;
        line-height: 22px !important;

        b {
            font-size: 16px !important;
        }
    }
`;

const MultiplePricesSwitchStyled = styled(ActionBarStyled)`
    display: flex;
    width: 100%;
    flex-flow: wrap;
    padding: 16px !important;
    font-size: 14px;
    margin: 0;
    justify-content: space-between;
    align-items: center;
    @media (min-width: ${BreakpointsEnum.sm}) {
        flex-direction: row-reverse;
        justify-content: flex-end;
        margin: 0;
    }
`;

const MultiplePricesSwitchLinkStyled = styled.a`
    color: ${({ theme }) => theme.link.primary};
    &:hover {
        color: ${({ theme }) => theme.link.primary};
    }
    text-decoration: underline;
    margin-left: 0px;
    line-height: 22px;
    font-weight: 600;
    @media (min-width: ${BreakpointsEnum.sm}) {
        margin-left: 8px;
    }
`;

const TrackableMultiplePricesSwitchLinkStyled = styled(Link)`
    color: ${({ theme }) => theme.link.primary};
    &:hover {
        color: ${({ theme }) => theme.link.primary};
    }
`;
export interface IProps {
    onToogle?: (isToggled: boolean) => void;
    isAllInclusiveSelected?: boolean;
    allInclusiveUrl?: string;
    allInclusiveDescription?: string;
    disabled?: boolean;
    className?: string;
}

const style: Record<string, React.CSSProperties> = {
    link: {
        textDecoration: 'underline',
    },
};

const trackingInfo = {
    event: 'whats_included',
    category: 'product page',
    action: 'whats included',
    label: 'show whats included',
};

export const MultiplePricesSwitch = ({
    onToogle,
    isAllInclusiveSelected,
    allInclusiveUrl,
    allInclusiveDescription,
    disabled,
    className,
}: IProps) => {
    const [showModal, setShowModal] = React.useState(false);

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleMoreInfoClick = (e) => {
        e.preventDefault();
        eventTracker.track(trackingInfo);
        setShowModal(true);
    };

    const TrackableLinkWhatsIncluded = TrackComponent(
        TrackableMultiplePricesSwitchLinkStyled,
        trackingInfo,
    );

    return (
        <MultiplePricesSwitchStyled className={className}>
            <div className="multiple-prices-switch__label-wrapper">
                <span className="multiple-prices-switch__label">
                    {__('showMeAllInclusive', 'dreamlines')}
                </span>

                {!!allInclusiveUrl && !allInclusiveDescription && (
                    <TrackableLinkWhatsIncluded
                        className="multiple-prices-switch__link"
                        style={style.link}
                        target="_blank"
                        href={`/${allInclusiveUrl}`}
                    >
                        {__('whatIsIncluded', 'dreamlines')}
                    </TrackableLinkWhatsIncluded>
                )}

                {!!allInclusiveUrl && allInclusiveDescription && (
                    <MultiplePricesSwitchLinkStyled
                        onClick={handleMoreInfoClick}
                        href={`/${allInclusiveUrl}`}
                    >
                        {__('whatIsIncluded', 'dreamlines')}
                    </MultiplePricesSwitchLinkStyled>
                )}
            </div>

            <div className="multiple-prices-switch__switch-wrapper">
                <ToggleSwitch
                    onToogle={onToogle}
                    isToggled={isAllInclusiveSelected}
                    disabled={disabled}
                />
            </div>

            {showModal &&
                createPortal(
                    <StyledModal isOpen onClose={handleModalClose}>
                        <div
                            className="allInclusiveDescription"
                            dangerouslySetInnerHTML={{ __html: allInclusiveDescription }}
                        />
                    </StyledModal>,
                    document.body,
                )}
        </MultiplePricesSwitchStyled>
    );
};
